import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWheelchairNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6 6a6 6 0 105.988 6.383l4.021 1.34a4 4 0 101.49-2.847l-.34-1.361A2 2 0 0015.22 8H14v2h1.22l.368 1.475-3.867-1.289A6.003 6.003 0 006 6zm-4 6a4 4 0 017.603-1.74l-4.78.956.393 1.96 4.778-.955A4 4 0 012 12zm16.04 2.4l2.592.865.633-1.897-2.592-.864a2 2 0 11-.633 1.897z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWheelchairNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWheelchairNormalSmall;
